import { getSupplierRetailersAll, getProductsAll, getProducts } from './api/suppliers';
import { postPermissions } from './permissions';
import { alertSuccess, alertError } from './alert';
import { formatMany } from '../../utils/formatHelper';

import { setProductFiltersSetFilters, setProductFiltersOrder, setProductFiltersOrderField } from './productFilters';

import {
  PRODUCTS_REPLENISH,
  PRODUCTS_REPLENISH_ALL,
  PRODUCTS_REPLENISH_COUNT,
  PRODUCTS_REPLENISH_CHECK_ALL_ON_PAGE,
  PRODUCTS_REPLENISH_UNCHECK_ALL,
  PRODUCTS_REPLENISH_CHECK,
  PRODUCTS_REPLENISH_UNCHECK,
  PRODUCTS_REPLENISH_SEARCH,
  PRODUCTS_REPLENISH_OFFSET,
  PRODUCTS_REPLENISH_RETAILERS,
  PRODUCTS_REPLENISH_LOADING,
} from '../constants/productsReplenishTypes';

import { ORDER_TYPE_REPLENISH } from '../../constants/orderTypes';
import { getTotalCountHeader } from './api/utils';

export const setProductsReplenish = (data) => ({ type: PRODUCTS_REPLENISH, payload: data });
const setProductsReplenishAll = (data) => ({ type: PRODUCTS_REPLENISH_ALL, payload: data });
const setProductsReplenishCount = (count) => ({ type: PRODUCTS_REPLENISH_COUNT, payload: count });

export const productsReplenishSubmit = (value) => async (dispatch, getState) => {
  if (value) {
    try {
      const state = getState();
      const { checked, retailers } = state.productsReplenish;
      const { supplierId } = state.role;

      const variants = [];

      Object.keys(checked).forEach((model) => {
        checked[model].forEach((variantId) => {
          variants.push(variantId.id || variantId);
        });
      });

      const retailerIds = retailers.map((retailer) => retailer.id).filter((id) => value.retailers.includes(id));

      const data = [
        {
          retailer_ids: retailerIds,
          variant_ids: variants,
          replenish_approved: value.replenishment,
        },
      ];

      const response = await postPermissions(supplierId, data);

      if (response && response.data.success) {
        if (value.dropship || value.replenishment) {
          dispatch(
            alertSuccess(
              `${Object.keys(checked).length} ${formatMany(
                Object.keys(checked).length,
                'product',
              )} successfully approved for 
                            ${retailerIds.length} ${formatMany(retailerIds.length, 'retailer')}`,
            ),
          );
        } else {
          dispatch(
            alertSuccess(
              `${Object.keys(checked).length} ${formatMany(
                Object.keys(checked).length,
                'product',
              )} successfully revoked from 
                            ${retailerIds.length} ${formatMany(retailerIds.length, 'retailer')}`,
            ),
          );
        }
      }

      dispatch(productsReplenishUncheckAll);
    } catch (error) {
      dispatch(alertError(error));
    }
  }
};

export const productsReplenishCheckAllOnPage = (ids) => ({ type: PRODUCTS_REPLENISH_CHECK_ALL_ON_PAGE, payload: ids });

export const productsReplenishCheckAll = () => async (dispatch, getState) => {
  const state = getState();
  const { search } = state.productsReplenish;
  const { supplierId } = state.role;
  const { currentFilters } = state.productFilters;

  try {
    const responseAll = await getProductsAll(supplierId, currentFilters, search, ORDER_TYPE_REPLENISH);
    dispatch(setProductsReplenishAll(responseAll.data));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const productsReplenishUncheckAll = { type: PRODUCTS_REPLENISH_UNCHECK_ALL };

export const productsReplenishCheck = (id) => async (dispatch) => {
  dispatch({ type: PRODUCTS_REPLENISH_CHECK, payload: id });
};

export const productsReplenishUncheck = (id) => async (dispatch) => {
  dispatch({ type: PRODUCTS_REPLENISH_UNCHECK, payload: id });
};

export const getProductsReplenish = () => async (dispatch, getState) => {
  const state = getState();
  const { perPage, offset, count, search } = state.productsReplenish;
  const { supplierId } = state.role;
  const { currentFilters, order, orderField } = state.productFilters;

  try {
    dispatch({ type: PRODUCTS_REPLENISH_LOADING, payload: { products: true } });
    const undefinedRetailerId = undefined;
    const response = await getProducts(
      supplierId,
      currentFilters,
      offset,
      perPage,
      search,
      order,
      orderField,
      ORDER_TYPE_REPLENISH,
      undefinedRetailerId,
    );

    const newCount = getTotalCountHeader(response);
    if (count !== newCount) {
      dispatch(setProductsReplenishCount(newCount));
    }

    dispatch(setProductsReplenish(response.data));
    dispatch({ type: PRODUCTS_REPLENISH_LOADING, payload: { products: false } });
  } catch (error) {
    dispatch(alertError(error));
    dispatch({ type: PRODUCTS_REPLENISH_LOADING, payload: { products: false } });
  }
};

export const setProductsReplenishSearch = (search) => (dispatch) => {
  dispatch({ type: PRODUCTS_REPLENISH_SEARCH, payload: search });
  dispatch(setProductsReplenishOffset(0));
};

export const setProductsReplenishOffset = (offset) => (dispatch) => {
  dispatch({ type: PRODUCTS_REPLENISH_OFFSET, payload: offset });
  dispatch(getProductsReplenish());
};

export const setProductsReplenishOrderField = (orderField) => (dispatch, getState) => {
  dispatch(setProductFiltersOrderField(orderField));
  dispatch(getProductsReplenish());
};

export const setProductsReplenishOrder = (order) => async (dispatch) => {
  dispatch(setProductFiltersOrder(order));
  dispatch(getProductsReplenish());
};

export const setProductsReplenishCurrentFilter = (filters) => (dispatch) => {
  dispatch(setProductFiltersSetFilters(filters));
  dispatch(setProductsReplenishOffset(0));
};

export const getProductsReplenishRetailers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { supplierId } = state.role;

    const response = await getSupplierRetailersAll(supplierId);

    dispatch({ type: PRODUCTS_REPLENISH_RETAILERS, payload: response.data });
  } catch (error) {
    dispatch(alertError(error));
  }
};
